// The API opens its MySQL pool with dateStrings: true, so TIMESTAMP/DATETIME columns (quotes.expires_at, tasks.due_date, ...)
// arrive as "2026-10-30 00:00:00" (a space, not a "T"). DATE columns arrive as "2026-10-30".
// dateOnly() gives the "YYYY-MM-DD" part of either form (or an ISO string), which is what <input type="date"> and
// new Date(`${value}T00:00:00`) need.
export const dateOnly = (value) => (value ? String(value).split(/[T ]/)[0] : '');
